import { render, staticRenderFns } from "./CreateVariable.vue?vue&type=template&id=7c0fb590&scoped=true&"
import script from "./CreateVariable.vue?vue&type=script&lang=ts&"
export * from "./CreateVariable.vue?vue&type=script&lang=ts&"
import style0 from "./CreateVariable.vue?vue&type=style&index=0&id=7c0fb590&prod&lang=scss&scoped=true&"
import style1 from "./CreateVariable.vue?vue&type=style&index=1&id=7c0fb590&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0fb590",
  null
  
)

export default component.exports